import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const GalleryAlbum = ({ album }) => {
  const sliderRef = useRef(null);

  const scroll = (dir) => {
    sliderRef.current?.scrollBy({
      left: dir === "left" ? -280 : 280,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {/* ALBUM HEADER */}
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <p className="text-sm font-semibold text-foreground">{album.title}</p>
          <p className="text-[11px] text-muted-foreground">
            {album.location} •{" "}
            {new Date(album.date).toLocaleDateString("id-ID", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </p>
        </div>

        <span className="rounded-full bg-secondary px-3 py-1 text-[10px] font-medium text-muted-foreground">
          {album.category}
        </span>
      </div>

      {/* MOBILE SLIDER */}
      <div className="relative md:hidden">
        <div
          ref={sliderRef}
          className="flex gap-3 overflow-x-auto snap-x snap-mandatory no-scrollbar"
        >
          {album.images.map((img) => (
            <div
              key={img.id}
              className="relative min-w-[80%] snap-start overflow-hidden rounded-2xl aspect-[4/5] bg-secondary"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="object-cover w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* NAV */}
        <div className="flex justify-end gap-2 mt-3">
          <button
            onClick={() => scroll("left")}
            className="flex items-center justify-center rounded-full h-7 w-7 bg-secondary"
          >
            <ChevronLeft size={14} />
          </button>
          <button
            onClick={() => scroll("right")}
            className="flex items-center justify-center rounded-full h-7 w-7 bg-secondary"
          >
            <ChevronRight size={14} />
          </button>
        </div>
      </div>

      {/* DESKTOP GRID */}
      <div className="hidden grid-cols-4 gap-3 md:grid">
        {album.images.map((img) => (
          <div
            key={img.id}
            className="relative overflow-hidden rounded-2xl aspect-[4/5] bg-secondary"
          >
            <img
              src={img.src}
              alt={img.alt}
              className="h-full w-full object-cover transition-transform duration-300 hover:scale-[1.05]"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <p className="max-w-2xl mt-4 text-xs text-muted-foreground sm:text-sm">
        {album.description}
      </p>
    </div>
  );
};

export default GalleryAlbum;
